<div class="mobile-upload-container">
  <header class="app-header">
    <span class="material-icons header-icon">cloud_upload</span>
    <h1>{{ 'ATTACHMENT.MOBILE_UPLOAD' | translate }}</h1>
  </header>

  <main class="content-wrapper">
    @if (isLoadingInfo()) {
    <div class="status-container">
      <span class="material-icons loading-icon spinner">sync</span>
      <p>{{ 'ATTACHMENT.LOADING_INFO' | translate }}</p>
    </div>
    } @else if (errorLoadingInfo()) {
    <div class="status-container error">
      <span class="material-icons status-icon">error_outline</span>
      <p class="error-text">{{ errorLoadingInfo() }}</p>
    </div>
    } @else {
    <!-- Details Card -->
    <div class="card details-card">
      @if (uploadType === 'patient') {
      <h2 class="target-title">
        {{ targetName() }}
      </h2>
      <span class="badge badge-patient">{{
        'ATTACHMENT.PATIENT_RECORD' | translate
      }}</span>
      } @else {
      <h2 class="target-title">
        {{ 'ATTACHMENT.WORK_ORDER_RECORD' | translate }} #{{ workOrderNo() }}
      </h2>
      <span class="badge badge-workorder">{{
        'ATTACHMENT.WORK_ORDER_RECORD' | translate
      }}</span>
      }
    </div>

    @if (uploadSuccess()) {
    <!-- Success Screen -->
    <div class="success-card card text-center">
      <span class="material-icons check-icon">check_circle</span>
      <h3>{{ 'ATTACHMENT.UPLOAD_SUCCESS' | translate }}.</h3>
      <p class="info-text">{{ 'ATTACHMENT.CLOSE_PAGE' | translate }}</p>

      <button class="btn btn-secondary full-width" (click)="uploadAnother()">
        <span class="material-icons">add_photo_alternate</span>
        {{ 'ATTACHMENT.ANOTHER_UPLOAD' | translate }}
      </button>
    </div>
    } @else {
    <!-- Upload Form -->
    <div class="card form-card">
      <!-- Document Type selection -->
      <div class="form-group">
        <label for="doc-type">{{
          'ATTACHMENT.DOCUMENT_TYPE_LABEL' | translate
        }}</label>
        <div class="select-wrapper">
          <select
            id="doc-type"
            [ngModel]="selectedDocType()"
            (ngModelChange)="selectedDocType.set($event)"
            class="form-control"
          >
            @for (opt of documentTypes(); track opt.value) {
            <option [value]="opt.value">{{ opt.label | translate }}</option>
            }
          </select>
          <span class="material-icons select-arrow">arrow_drop_down</span>
        </div>
      </div>

      <!-- Selected File View -->
      @if (selectedFile()) {
      <div class="file-preview">
        <span class="material-icons file-icon">insert_drive_file</span>
        <div class="file-meta">
          <span class="file-name">{{ selectedFile()?.name }}</span>
          <span class="file-size"
            >{{ (selectedFile()!.size / 1024 / 1024).toFixed(2) }} MB</span
          >
        </div>
        <button
          class="remove-file"
          (click)="selectedFile.set(null)"
          type="button"
        >
          <span class="material-icons">cancel</span>
        </button>
      </div>
      }

      <!-- Selection Buttons -->
      <div class="buttons-grid">
        <input
          type="file"
          #cameraInput
          (change)="onFileSelected($event)"
          accept="image/*"
          capture="environment"
          class="file-input-hidden"
        />

        <input
          type="file"
          #galleryInput
          (change)="onFileSelected($event)"
          accept="*/*"
          class="file-input-hidden"
        />

        <button
          type="button"
          class="btn btn-action btn-camera"
          (click)="triggerFileInput(cameraInput)"
        >
          <span class="material-icons btn-icon">photo_camera</span>
          {{ 'ATTACHMENT.TAKE_PHOTO' | translate }}
        </button>

        <button
          type="button"
          class="btn btn-action btn-gallery"
          (click)="triggerFileInput(galleryInput)"
        >
          <span class="material-icons btn-icon">photo_library</span>
          {{ 'ATTACHMENT.CHOOSE_FILE' | translate }}
        </button>
      </div>

      @if (errorMessage()) {
      <div class="error-msg">
        <span class="material-icons">info</span>
        <span>{{ errorMessage() }}</span>
      </div>
      }

      <!-- Upload Progress -->
      @if (isUploading()) {
      <div class="progress-bar-container">
        <div class="progress-bar-track">
          <div
            class="progress-bar-fill"
            [style.width.%]="uploadProgress()"
          ></div>
        </div>
        <p class="progress-text">{{ 'loading' | translate }}</p>
      </div>
      }

      <!-- Action Button -->
      <button
        type="button"
        class="btn btn-primary btn-upload full-width"
        [disabled]="!selectedFile() || isUploading()"
        (click)="upload()"
      >
        <span class="material-icons btn-icon">publish</span>
        {{ 'ATTACHMENT.UPLOAD_BTN' | translate }}
      </button>
    </div>
    } }
  </main>
</div>
